import React from 'react'

const SeniorDivision = () => {
    return (
        <>

            <section className="section-sp1 mid-light">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <h4 className="title-head" style={{ textAlign: "justify" }}>
                                Reliable Offers Classroom As Well As Online Classes For Class 06th To 12th And 12th Passed. The Courses Are Divided Into Two Sections
                            </h4>
                            <h2 className='text-center pt-5'>JEE (Main+Adv.) / JEE Main</h2>
                            <p style={{ textAlign: "justify", lineHeight: 2 }}>Reliable Institute over the past years has proved its excellence though the outstanding results in JEE Main and JEE Advanced Examinations. Our course structure is designed in a way to cater for the academic needs of aspirants. Our study material has been designed after rigorous research by the subject experts. In addition to JEE (Main+Advanced), students will also receive support for other competitive exams like KVPY and Olympiads.</p>
                            <div className="row">
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h4 className='text-center'>Class XI</h4>
                                        <button type="button" className="btn btn-outline-danger btn-md">
                                            <a href="https://reliablekota.com/courses/stream-wise/class-11/" style={{ textDecoration: "none" }}>
                                                View Details
                                            </a>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h4 className='text-center'>Class XII</h4>
                                        <button type="button" className="btn btn-outline-danger btn-md">
                                            <a href="https://reliablekota.com/courses/stream-wise/class-12/" style={{ textDecoration: "none" }}>
                                                View Details
                                            </a>
                                        </button>
                                    </div>
                                </div>
                                <div className="col-lg-4 pt-4">
                                    <div className="services-bx">
                                        <h4 className='text-center'>Class XIII</h4>
                                        <button type="button" className="btn btn-outline-danger btn-md">
                                            <a href="https://reliablekota.com/courses/stream-wise/class-13/" style={{ textDecoration: "none" }}>
                                                View Details
                                            </a>
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                        {/* <div className="row justify-content-center">
                            <div className="col-lg-4">
                                <div className="servicesBox" style={{ width: "100%", maxWidth: "300px" }}>
                                    <h4 className='text-center'>Class XI</h4>
                                    <button type="button" className="btn btn-outline-danger btn-md">
                                        <a href="https://reliablekota.com/courses/stream-wise/class-11/" style={{ textDecoration: "none" }}>
                                            View Details
                                        </a>
                                    </button>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="servicesBox" style={{ width: "100%", maxWidth: "300px" }}>
                                    <h4 className='text-center'>Class XII</h4>
                                    <button type="button" className="btn btn-outline-danger btn-md">
                                        <a href="https://reliablekota.com/courses/stream-wise/class-12/" style={{ textDecoration: "none" }}>
                                            View Details
                                        </a>
                                    </button>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <div className="servicesBox" style={{ width: "100%", maxWidth: "300px" }}>
                                    <h4 className='text-center'>Class XIII</h4>
                                    <button type="button" className="btn btn-outline-danger btn-md">
                                        <a href="https://reliablekota.com/courses/stream-wise/class-13/" style={{ textDecoration: "none" }}>
                                            View Details
                                        </a>
                                    </button>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </section>

        </>
    )
}

export default SeniorDivision